import type { Ingredient, Meal } from './api';

// Ingredient amounts that signal a freebie/seasoning rather than a measured
// quantity. Drop these so the on-screen ingredient list shows actual food
// to cook, not "salt to taste · black pepper to taste".
export const SEASONING_AMOUNTS = new Set(['to taste', 'generous', 'unlimited', '']);

// Ingredient names that are always seasonings/drinks even when the amount is
// quantitative (e.g. "300ml black coffee"). Word-boundary anchored so
// "saltimbocca" is not matched.
export const SEASONING_NAME_RE = /\b(salt|pepper|coffee|tea|water)\b/i;

// filteredIngredients returns the meal's ingredients with seasonings/drinks
// removed. Falls back to an empty array when the template is missing.
export function filteredIngredients(template: Meal | undefined): Ingredient[] {
  if (!template) return [];
  return template.ingredients.filter((i) => {
    const amt = (i.amount ?? '').trim().toLowerCase();
    if (SEASONING_AMOUNTS.has(amt)) return false;
    if (SEASONING_NAME_RE.test(i.item)) return false;
    return true;
  });
}
